import { DeploymentUnitOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import { ListPageIntro, ListPageShell } from '../../common'

export const ReleaseCreate = () => {
	return (
		<ListPageShell>
			<ListPageIntro
				icon={DeploymentUnitOutlined}
				title="Create release"
				subtitle="Create a new release record."
			/>
			<Empty description="Release creation form is coming soon." />
		</ListPageShell>
	)
}
